import React, { useState, useCallback, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
// import Collapse, { Panel } from 'rc-collapse';
import Icon from '../../Icon';
import CustomTooltip from '../../Tooltip';
import FormGroup from '../../FormGroup';
import CustomNotify from '../../Notify';
import ClipboardCopy from '../../../helpers/ClipboardCopy';
import config, { statuses } from '../../../config';
import Button from "../../Button";
import { I18nContext } from 'utils/I18n/context';

const promocode = 'promocode';

const Constructor = (props) => {
    const { t } = useContext(I18nContext);
    const resultRef = useRef(null);
    
    const [state, setState] = useState({
        creativeType: 'link',
        creativeId: '',
        goalEntryId: '',
        goalEntries: [],
        publisherId: '',
        links: [],
        currentLink: {},
        metaParams: {},
        selfieLink: '',
        landing: { is_external: false, external_url: '' },
        promocode: {},
        promoTitle: '',
        description: '',
        errors: []
    });

    const getLinkParams = useCallback(() => {
        const linkIdParam = state.currentLink?.id ? `?l=${state.currentLink.id}` : '?l=';
        const selfie = state.selfieLink;
        if (selfie && state.currentLink && state.currentLink.selfie_link) {
            return linkIdParam + '&sl=' + encodeURIComponent(selfie);
        }
        return linkIdParam;
    }, [state.currentLink, state.selfieLink]);

    const getResultLink = useCallback((promo) => {
        let metaParams = getMetaParams();

        if(promo && promo.params) {
            metaParams = '';
            let promoParams = typeof promo.params === "string" ? JSON.parse(promo.params) : promo.params;

            if(promoParams !== undefined && promoParams !== null) {
                Object.keys(promoParams).map((key) => {
                    if (promoParams[key] && String(promoParams[key]).length > 0) {
                        metaParams = metaParams + '&' + key + '=' + promoParams[key];
                    }
                });
            }
        }

        metaParams = metaParams + '&creative_type=' + state.creativeType + '&creative_id=' + state.creativeId;

        return `${props.offer?.tds_domain}/${state.publisherId}/${state.goalEntryId}${getLinkParams()}${metaParams}`;
    }, [state, props.offer, getMetaParams, getLinkParams]);

    const getFirstGoal = useCallback(() => {
        let goal = state.goalEntries ? (state.goalEntries.find(g => g.access_granted) || {}) : {};
        return goal.id;
    }, [state.goalEntries]);

    const getMetaParams = useCallback(() => {
        let metaParams = Object.keys(state.metaParams).map((paramKey) => {
            let value = state.metaParams[paramKey];
            return value ? paramKey + '=' + value : ''
        });

        metaParams = metaParams.filter(n => {
            return n && n !== '&'
        });
        return metaParams.length ? '&' + metaParams.join('&') : '';
    }, [state.metaParams]);

    const getStatusIcon = useCallback(() => {
        const dataGoal = state.goalEntries.filter((item) => item.id === state.goalEntryId)[0] || {};

        return dataGoal.status === statuses.paused
            ? (
                <CustomTooltip id={`icon-paused-constructor`} tooltip={t?.offersPage?.offer?.paused || 'Paused'}>
                    <Icon name={`link-construrtor__label-icon fa fa-pause-circle`} />
                </CustomTooltip>
            )
            : null;
    }, [state.goalEntries, state.goalEntryId, t]);

    const setSelfieLink = useCallback((e) => {
        setState(prev => ({
            ...prev,
            selfieLink: e.target.value
        }));
    }, []);

    const onGoalChange = useCallback((e) => {
        setState(prev => ({
            ...prev,
            goalEntryId: e.target.value
        }));
    }, []);

    const onLinkChange = useCallback((e) => {
        setState(prev => ({
            ...prev,
            currentLink: prev.links.find((link) => link.id === e.target.value)
        }));
    }, []);

    const getAllowChar = useCallback(() => {
        return /[^\da-zA-Z.%_{}\[\]#$\-]/g;
    }, []);

    const onErrorMsg = useCallback((key) => {
        CustomNotify(t?.constructors?.[key] || 'Error', 'error');
    }, [t]);

    const onCopyButtonClick = useCallback((key) => {
        ClipboardCopy.copy(resultRef.current);
        CustomNotify(t?.constructors?.[key] || 'Copied');

        props.onSave?.(state, t, onSuccess, onError);
    }, [state, t, props]);

    const onChangeExternalLink = useCallback((e) => {
        let landing = { ...state.landing };
        landing.is_external = e.target.checked;
        if(!e.target.checked) {
            landing.external_url = '';
        }

        setState(prev => ({
            ...prev,
            landing: landing
        }));
    }, [state.landing]);

    const addExternalLink = useCallback((e) => {
        let landing = { ...state.landing };
        landing.external_url = (e.target.value).trim();

        setState(prev => ({
            ...prev,
            landing: landing
        }), () => {
            getCode(landing);
        });
    }, [state.landing]);

    const renderGoalEntries = useCallback(() => {
        let editPromoCode = false;
        if(state.promocode && state.promocode.id) {
            editPromoCode = true;
        }
        return (
            <div className="form-group">
                <label className="control-label">{t?.constructors?.goal || 'Goal'}</label>
                {getStatusIcon()}
                <select onChange={onGoalChange} value={state.goalEntryId}
                        className="form-control"
                        disabled={editPromoCode}
                >
                    {
                        state.goalEntries.map((goal, key) => {
                            return <option key={key} disabled={!goal.access_granted} value={goal.id}>{goal.goal.title}</option>
                        })
                    }
                </select>
            </div>
        );
    }, [state, t, getStatusIcon, onGoalChange]);

    const getMetaUtmParamValue = useCallback((promoType, key) => {
        if(promocode === promoType) {
            if(state[promoType] && state[promoType].settings) {
                if(typeof state[promoType].settings === "string") {
                    let params = JSON.parse(state[promoType].settings);
                    return params && params[key] ? params[key] : '';
                }
                return state[promoType].settings[key] ? state[promoType].settings[key] : '';
            }
            if(state.params && state.params[key]) {
                return state.params[key];
            }
            return '';
        }

        if(state[promoType] && state[promoType].params) {
            if(typeof state[promoType].params === "string") {
                let params = JSON.parse(state[promoType].params);
                return params && params[key] ? params[key] : '';
            }
            return state[promoType].params[key] ? state[promoType].params[key] : '';
        }

        if(state.params && state.params[key]) {
            return state.params[key];
        }

        return '';
    }, [state]);

    const renderParams = useCallback((promoType) => {
        const onChangeParam = (e) => {
            if (e.target.value.replace(getAllowChar(), '') !== e.target.value) {
                onErrorMsg('notAllowCharMsg');
                return false;
            }
            const key = e.target.placeholder;
            const value = e.target.value;
            setState(prev => ({
                ...prev,
                metaParams: { ...prev.metaParams, [key]: value }
            }));
        };
        return (
            <div className="form-group">
                <label className="control-label bold">{t?.constructors?.utm || 'UTM'}</label>
                <div className="form-row">
                    {config.metaUtmParams.map(key => {
                        let value = getMetaUtmParamValue(promoType, key);
                        return (
                            <input
                                type="text"
                                maxLength="50"
                                onChange={onChangeParam}
                                placeholder={key}
                                className="form-control"
                                value={value}
                                key={key}
                            />
                        )
                    })}
                </div>
            </div>
        );
    }, [t, getMetaUtmParamValue, getAllowChar, onErrorMsg]);

    const getMetaParamValue = useCallback((promoType, index) => {
        if(promocode === promoType) {
            if(state[promoType] && state[promoType].settings) {
                if(typeof state[promoType].settings === "string") {
                    let params = JSON.parse(state[promoType].settings);
                    return params && params['param' + (index + 1)] ? params['param' + (index + 1)] : '';
                }
                return state[promoType].settings['param' + (index + 1)]
                    ? state[promoType].settings['param' + (index + 1)] : '';
            }
            if(state.params && state.params['param' + (index + 1)]) {
                return state.params['param' + (index + 1)];
            }
            return '';
        }

        if(state[promoType] && state[promoType].params) {
            if(typeof state[promoType].params === "string") {
                let params = JSON.parse(state[promoType].params);
                return params && params['param' + (index + 1)] ? params['param' + (index + 1)] : '';
            }
            return state[promoType].params['param' + (index + 1)]
                ? state[promoType].params['param' + (index + 1)] : '';
        }

        if(state.params && state.params['param' + (index + 1)]) {
            return state.params['param' + (index + 1)];
        }

        return '';
    }, [state]);

    const renderSubMetaParams = useCallback((promoType) => {
        const onChangeParam = (e) => {
            if (e.target.value.replace(getAllowChar(), '') !== e.target.value) {
                onErrorMsg('notAllowCharMsg');
                return false;
            }
            const key = e.target.placeholder;
            const value = e.target.value;
            setState(prev => ({
                ...prev,
                metaParams: { ...prev.metaParams, [key]: value }
            }));
        };
        return (
            <div className="form-group">
                <label className="control-label bold">{t?.constructors?.subaccount || 'Subaccount'}</label>
                <div className="form-row">
                    {Array.from(Array(config.metaParamsCount).keys()).map((index) => {
                        let value = getMetaParamValue(promoType, index);
                        return (
                            <input type="text" maxLength="50"
                               onChange={onChangeParam}
                               placeholder={'param' + (index + 1)}
                               className="form-control"
                               value={value}
                               key={index}
                            />
                        )
                    })}
                </div>
            </div>
        )
    }, [t, getMetaParamValue, getAllowChar, onErrorMsg]);

    const renderSelfieLink = useCallback(() => {
        return (
            <React.Fragment>
                <div className="hr-line-dashed" />
                <FormGroup
                    label={'Selfie link'}
                >
                    <input
                        type="text"
                        maxLength="255"
                        value={state.selfieLink}
                        onChange={setSelfieLink}
                        placeholder="Selfie link"
                        className="form-control"
                    />
                </FormGroup>
            </React.Fragment>
        );
    }, [state.selfieLink, setSelfieLink]);

    const renderOfferLinks = useCallback(() => {
        return (
            <div className="form-group">
                <label className="control-label">{t?.constructors?.link || 'Link'}</label>
                {getStatusIcon()}
                <select onChange={onLinkChange} value={state.currentLink.id}
                        className="form-control">
                    {
                        state.links.map((link, key) => {
                            return <option key={key} value={link.id}>{link.title}</option>
                        })
                    }
                </select>
            </div>
        );
    }, [state, t, getStatusIcon, onLinkChange]);

    const renderLandingParams = useCallback(() => {
        return (
            <React.Fragment>
                <label className="checkbox-inline option">
                    <input
                        className="option__input"
                        type="checkbox"
                        name={'type'}
                        checked={state.landing.is_external}
                        value={state.landing.is_external ? state.landing.is_external : ''}
                        onChange={onChangeExternalLink}
                    />
                    <span className="option__mark" />
                    <span className="option__caption">{t?.constructors?.externalHosting || 'External Hosting'}</span>
                </label>
                <FormGroup>
                    <input
                        className="form-control external_url"
                        type="text"
                        readOnly={!state.landing.is_external}
                        required={false}
                        placeholder={t?.constructors?.externalLandingLink || 'External Landing Link'}
                        style={{minHeight: 38, maxHeight: 38}}
                        onChange={addExternalLink}
                        value={state.landing.is_external ? state.landing.external_url : ''}
                    />
                </FormGroup>
            </React.Fragment>
        );
    }, [state.landing, t, onChangeExternalLink, addExternalLink]);

    const renderPromoCodeDescription = useCallback(() => {
        let editPromoCode = false;

        if(state.promocode && state.promocode.id) {
            editPromoCode = true;
        }

        return (
            <div className="form-group">
                <label className="control-label">{t?.constructors?.description || 'Description'}</label>
                <textarea
                    className="form-control"
                    maxLength="255"
                    name="description"
                    onChange={setDescrioption}
                    value={state.description || ""}
                    readOnly={editPromoCode}
                    style={{background: editPromoCode ? '#F6F6F6' : '#ffffff'}}
                />
            </div>
        );
    }, [state, t]);

    const renderPromoCode = useCallback(() => {
        let editPromoCode = false;

        if(state.promocode && state.promocode.id) {
            editPromoCode = true;
        }

        return (
            <div className="form-group">
                <div className="form-row">
                    <div className="form-row__promocode">
                        <label className="control-label">{t?.constructors?.promocode || 'Promo Code'}</label>
                        {state.errors && state.errors.length
                            ? <span className="error-message help-block">{t?.constructors?.promoCodeError || 'Error'}</span>
                            : null
                        }
                        <input type="text"
                               maxLength="50"
                               placeholder='Promo Code'
                               className={state.errors && state.errors.length
                                    ? "form-control has-error"
                                    : "form-control"
                               }
                               id="promocode"
                               value={state.promoTitle || ""}
                               onChange={setPromoCode}
                               required={true}
                               readOnly={editPromoCode}
                        />
                        <Button
                            type={'button'}
                            extraClass={{ 'generate-btn': true }}
                            text={t?.constructors?.generate || 'Generate'}
                            onClick={generatePromoCode}
                            disabled={editPromoCode}
                        />
                    </div>
                </div>
            </div>
        );
    }, [state, t]);

    const constructorMethods = {
        getResultLink,
        getFirstGoal,
        getMetaParams,
        getStatusIcon,
        setSelfieLink,
        onGoalChange,
        onLinkChange,
        getAllowChar,
        onErrorMsg,
        onCopyButtonClick,
        onChangeExternalLink,
        addExternalLink,
        renderGoalEntries,
        getMetaUtmParamValue,
        renderParams,
        getMetaParamValue,
        renderSubMetaParams,
        renderSelfieLink,
        renderOfferLinks,
        renderLandingParams,
        renderPromoCodeDescription,
        renderPromoCode,
        state,
        setState,
        resultRef
    };

    return constructorMethods;
};

Constructor.propTypes = {
    offer: PropTypes.object,
    onSave: PropTypes.func
};

Constructor.defaultProps = {
    offer: {},
    onSave: () => {}
};

export default Constructor;